import _createClass from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

/**
 * @packageDocumentation
 * @module Voice
 * @publicapi
 * @internal
 */
var TwilioError = /*#__PURE__*/function (_Error) {
  _inherits(TwilioError, _Error);

  var _super = _createSuper(TwilioError);

  function TwilioError(messageOrError, error) {
    var _this;

    _classCallCheck(this, TwilioError);

    _this = _super.call(this);
    Object.setPrototypeOf(_assertThisInitialized(_this), TwilioError.prototype);
    var message = typeof messageOrError === 'string' ? messageOrError : _this.explanation;
    var originalError = typeof messageOrError === 'object' ? messageOrError : error;
    _this.message = "".concat(_this.name, " (").concat(_this.code, "): ").concat(message);
    _this.originalError = originalError;
    return _this;
  }

  return _createClass(TwilioError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { TwilioError as default };